import { useDomainAccessControl } from '../domain/accessControl'
import { FeatureToggle } from '../../access-control/featureToggles'

export const useIsShiftManagementM2Enabled = (): boolean => {
  const hasAccess = useDomainAccessControl()
  const hasFeatureFlagAccessUser = hasAccess([
    {
      featureToggles: [FeatureToggle.shiftManagementStabilityM2],
      restrictedBannersAllowed: true,
    },
  ])
  const hasFeatureFlagAccessWarehouse = hasAccess([
    {
      warehouseFeatureToggles: [FeatureToggle.shiftManagementStabilityM2],
      restrictedBannersAllowed: true,
    },
  ])

  return hasFeatureFlagAccessUser || hasFeatureFlagAccessWarehouse
}
